<template>
<div>
	<div   class="honor-container">
		<FormRow inline>
			<FormCol field="dedication">
				<option value="In memory of" checked>In memory of</option>
				<option value="In honor of">In honor of</option>
				<option value="For the recovery of">For the recovery of</option>
			</FormCol>
			<FormCol field="honoreeName" />
		</FormRow>
		<FormRow inline>
			<FormCol field="dedicationMessage" />
		</FormRow>
	</div>
</div>
</template>
<script lang="ts">
import { defineComponent, type PropType, ref, watch } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

export default defineComponent({
  props: {
    recipent: {
      type: Boolean,
      default: true
    }
  },	
  setup() {
	  const inHonorOf = true
	  const recipientFlag = true

	  const { setValue, form, settings } = usePaymentForm()

	  setValue('recipientName', 'Saranne Rosner')
	  setValue('honoreeName', 'Saranne Rosner')
	  setValue('recipientEmail', 'rosnerts@gmail.com')
	  setValue('dedication', 'In memory of')

	  return {
		  inHonorOf,
		  recipientFlag
	  }
  }
})
</script>
<style scoped lang="scss">
input[type="checkbox"] {
	margin-right: 7px;
}
.honor-container {
	margin-top: 20px;
}
.flex {
	display: flex;
	align-items: center;
}
.honor-type {
	max-width: 150px;
	min-width: 150px;
	margin-right: 7px;
}
.edit-recipient {
	color: $color-blue;
	font-size: 13px;
	cursor: pointer;
	&:hover {
		text-decoration: underline;
	}

}
</style>